export default "__VITE_PUBLIC_ASSET__996fdcae__"